export default __webpack_public_path__ + "static/media/HDTX_Pemanggilan RUPS 2023.56c2c48c.pdf";